import gql from 'graphql-tag';

export const CALENDAR_CONTACT_OPTIONS = gql`
  query CalendarContactOptions {
    dealActivity {
      result: calendarContactOptions {
        error
        success
        list {
          value
          label
        }
      }
    }
  }
`;
